import SimplLogo from 'assests/images/simpl.png'

export const Simpl = () => {
  return <img width={36} height={36} src={SimplLogo} alt="simpl" />
}